import React, { useEffect, useState, useCallback } from "react";
import { Box, Flex, Spinner } from "@chakra-ui/react";
import ApiResponse from "../../../services/ApiResponse";
import TableCRUD from "../../../components/TableCRUD";
import { NoticiaForTable } from "../../../services/models/Noticia";
import UnauthorizedPage from "../../UnauthorizedPage";
import ServerErrorPage from "../../ServerErrorPage";

const HEADERS = [
  "Título",
  "Resumen",
  "Visibilidad",
  "Estado",
  "Fecha Publicación",
  "Autor",
  "Tema",
  "Creado",
  "Actualizado"
];

const NoticiasTablePage = () => {
  const [response, setResponse] = useState(
    new ApiResponse<NoticiaForTable[]>()
  );

  const fetchNoticias = useCallback(async () => {
    const apiResponse = new ApiResponse<NoticiaForTable[]>();

    await apiResponse.useFetch("noticias/table", "GET");

    if (apiResponse.data) {
      apiResponse.data.sort((a, b) =>
        a.titulo.localeCompare(b.titulo)
      );
    }

    setResponse(apiResponse);
  }, []);

  useEffect(() => {
    fetchNoticias();
  }, [fetchNoticias]);

  /* ---------- LOADING ---------- */
  if (response.loading) {
    return (
      <Flex justify="center" align="center" height="100vh">
        <Spinner size="xl" thickness="4px" speed="0.65s" color="teal.500" />
      </Flex>
    );
  }

  /* ---------- RESPONSE ---------- */
  switch (response.responseCode) {
    case 200:
      return (
        <Box p={5} minH="100vh">
          <TableCRUD
            tableName="noticias"
            headers={HEADERS}
            data={response.data || []}
            infoColumn="titulo"
          />
        </Box>
      );

    case 401:
      return <UnauthorizedPage />;

    case 999:
    default:
      if (!response.loading && response.responseCode !== 0) {
        return <ServerErrorPage />;
      }
      return null;
  }
};

export default NoticiasTablePage;
